import moEngageUtils from "./moengage";

const analytics = {
  initialize: () => {
    moEngageUtils.initialize();
  },
  pageView: (screenName: string) => {
    moEngageUtils.trackEvent(`${screenName}_viewed`, {
      screen_name: screenName,
    });
  },
  trackEvent: (eventName: string, eventData?: Record<string, any>) => {
    try {
      moEngageUtils.trackEvent(eventName, eventData || {});
    } catch (error) {
      console.error("Error tracking event:", error);
    }
  },
  setUserAttributes: (attributes: Record<string, any>) => {
    console.log("attributes", attributes);
    try {
      moEngageUtils.setUserAttributes(attributes);
    } catch (error) {
      console.error("Error tracking event:", error);
    }
  },
  logout: async () => {
    try {
      await moEngageUtils.logout();
    } catch (error) {
      console.error("Error logging out of moengage:", error);
    }
  },
};

export default analytics;
